import React, {
  useState,
  useEffect,
} from "react";
import "./FxmsLogin.css";
import { FxmsData } from "../datas/FxData";
import { FxOpenButton } from "../inputs/FxOpenButton";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Button from "@mui/material/Button";
import * as authAction from "../jwt/auth-action";
import jwt_decode from "jwt-decode";
import { FxAlert, FxConfirm, FxWindow } from "../windows/FxWindows";
import { OauthLink } from "./OauthLink";

const FxmsLogin = (props) => {
  // const [email, setEmail] = useState("");
  // const [password, setPassword] = useState("");
  const [opNewApplyObj, setOpNewApplyObj] = useState(null);
  const [opFindIdPwObj, setOpFindIdPwObj] = useState(null);
  const snackbar = React.useRef(null);
  const fxConfirm = React.useRef(null);
  const [title, setTitle] = useState("Connecting...");
  const [copyright, setCopyright] = useState(
    "Copyrightⓒ2022 Thingspire All rights reserved."
  );
  const [open, setOpen] = useState(false); // Dialog 상태 true, false 선택
  const [message, setMessage] = useState("알 수 없는 오류발생"); // 로그인 오류 종류에 따라 메세지 다르게 보여줌
  const inputDatas = {};
  const [emailValue, setEmailValue] = useState("");
  const [passwordValue, setPasswordValue] = useState("");
  const [token, setToken] = useState("");
  const { REACT_APP_ENV } = process.env;

  // 컴포넌트가 마운트되었을 때와 토큰 값이 변경될 때 실행되는 부분
  useEffect(() => {
    // 이벤트 리스너 등록
    window.addEventListener("message", handleTokenEvent);
    // 컴포넌트가 언마운트될 때 이벤트 리스너 제거
    return () => {
      window.removeEventListener("message", handleTokenEvent);
    };
  }, []);

  // 토큰 이벤트 핸들러
  const handleTokenEvent = (event) => {
    const url = new URL(window.location.href);
    const tokenValue = url.searchParams.get("token");
    const exValue = url.searchParams.get("expirationTime");

    if (tokenValue) {
      authAction.loginTokenHandler(tokenValue, exValue);
      showApp(tokenValue);
    }
  };

  //로그아웃을 한건 토큰이 삭제되어 괜찮은데
  //유효기간 만료가 되었으나 토큰은 남아있어 불일치로 접속불가 오류 개선
  // useLayoutEffect(() => {
  //   const tokenData = authAction.retrieveStoredToken();
  //   if (tokenData) {
  //     //setToken(tokenData.token);
  //     authAction.loginTokenHandler(tokenData.token, tokenData.duration);
  //   }
  // }, []);

  useEffect(() => {
    // 화면 구성정보를 가져온 후 Application을 호출한다.
    FxWindow.setSnackbar(snackbar);
    FxWindow.setFxConfirm(fxConfirm);
    FxmsData.getNotLoginData()
      .then(function (res) {
        const rawTitle = FxmsData.getVarValue(
          "ui-title",
          "Thingspire Industrial Service Platform"
        );
        const title =
          String(rawTitle ?? "").replace(/\(\s*DEV\s*\)/gi, "").trim() ||
          "Thingspire Industrial Service Platform";

        setTitle(title);

        // 브라우저 타이틀변경
        document.title = title;

        setCopyright(
          FxmsData.getVarValue(
            "ui-copyright",
            "Copyrightⓒ2022 Thingspire All rights reserved."
          )
        );
        const op_new_user = FxmsData.getOpObj("ui-user-new-apply");
        if (op_new_user != null) {
          setOpNewApplyObj(op_new_user);
        }
        const op_fine_id_pw = FxmsData.getOpObj("ui-user-find-id-pw");
        if (op_fine_id_pw != null) {
          setOpFindIdPwObj(op_fine_id_pw);
        }
      })
      .catch(function (error) {});

    return () => {};
  }, []);

  const showApp = async (token) => {
    const userNo = jwt_decode(token).userNo;

    // 사용자번호를 보관한다.
    FxmsData.setLocalStorage(userNo, token);
    // 사용자 로그인 히스토리를 저장한다.
    // 2023.01.03, 김종훈 : 로그 이력은 백엔드에서 기록한다.
    // FxmsData.insert("fxUrUser/accsHst/true", {});

    // 화면 구성정보를 가져온 후 Application을 호출한다.
    FxmsData.getFxmsConfig(userNo, token)
      .then(function (res) {
        document.location.href = "/";
      })
      .catch(function (error) {
        handleOpen();
        setMessage("화면 구성정보를 가져오지 못했습니다.");
      });
  };

  const login = async (event) => {
    inputDatas.email = emailValue;
    inputDatas.password = passwordValue;

    if (inputDatas.email.length <= 0 || inputDatas.password.length <= 0) {
      handleOpen();
      setMessage("아이디/비밀번호를 입력해주세요.");
      return;
    }

    const result = await authAction.loginActionHandler(
      inputDatas.email,
      inputDatas.password // 평문 대신 암호문 전송
    );
    if (result !== null) {
      const loginData = result.data;
      try {
        authAction.loginTokenHandler(
          loginData.accessToken,
          loginData.accessTokenExpiresIn
        );
        if (result.status === 200) {
          await showApp(result.data.accessToken);
        }
      } catch (e) {
        handleOpen();
        setMessage("아이디/비밀번호를 확인해주세요.");
      }
    } else {
      handleOpen();
      setMessage("허가되지 않은 사용자입니다.");
    }
  };

  const handleOnKeyPress = (e) => {
    if (e.key === "Enter") {
      login();
    }
  };

  const onChangeText = (event) => {
    if (event.target.name == "email") {
      setEmailValue(event.target.value);
    } else if (event.target.name == "password") {
      setPasswordValue(event.target.value);
    }
  };

  // Dialog 열기
  const handleOpen = () => {
    setOpen(true);
  };

  // Dialog 닫기
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <div className="contentWrapper2">
        <Dialog open={open} onClose={handleClose}>
          <DialogContent>{message}</DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>닫기</Button>
          </DialogActions>
        </Dialog>
        <div className="login_error">
          <div className="loginBG">
            <div className="titleName">{title}</div>
            <input
              name="email"
              type="email"
              // value={email}
              // onChange={(e) => setEmail(e.target.value)}
              onChange={onChangeText}
              onKeyDown={handleOnKeyPress}
              value={emailValue}
              placeholder="아이디를 입력하세요"
            />
            <input
              name="password"
              type="password"
              // value={password}
              // onChange={(e) => setPassword(e.target.value)}
              onChange={onChangeText}
              onKeyDown={handleOnKeyPress}
              value={passwordValue}
              placeholder="패스워드를 입력하세요"
            />
            <div className="loginBtn">
              <a onClick={login}>로그인</a>
            </div>
            <div className="other">
              <FxOpenButton
                title={<>아이디/비밀번호<br/>찾기</>}
                opObj={opFindIdPwObj}
                className="loginApplyButton"
              />
              <FxOpenButton
                title="회원가입"
                opObj={opNewApplyObj}
                className="loginApplyButton"
                flag="signUp"
              />
            </div>
            {REACT_APP_ENV === "development" ? <OauthLink /> : null}
            <div className="copyrightLine">{copyright}</div>
          </div>
        </div>
      </div>
      <FxAlert snackbar={snackbar} />
      <FxConfirm fxConfirm={fxConfirm} />
    </>
  );
};

export { FxmsLogin };
